import { render, staticRenderFns } from "./ShippingCompaniesDetails.vue?vue&type=template&id=3f3fabd9&"
import script from "./ShippingCompaniesDetails.vue?vue&type=script&lang=ts&"
export * from "./ShippingCompaniesDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports